module.exports = __webpack_public_path__ + "img/ico-double-arrow-down-brown.ce18b589.svg";